module.exports = __webpack_public_path__ + "static/home-banner-f7ebb7e7bc55a439b37baa561f0f43d0.png";